import { render, staticRenderFns } from "./ProductDetail5.vue?vue&type=template&id=57819402&scoped=true"
import script from "./ProductDetail5.vue?vue&type=script&lang=js"
export * from "./ProductDetail5.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail5.vue?vue&type=style&index=0&id=57819402&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57819402",
  null
  
)

export default component.exports